import CloseIcon from '@mui/icons-material/Close';
import { Drawer, IconButton, Paper, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SUPPORT_CONTENT_MAP } from 'FRONTEND/components/SupportDrawer/contentMap';
import { close as closeSupportDrawer } from 'FRONTEND/reducers/supportDrawerSlice';
import i18n from 'FRONTEND/utils/i18n';

const SupportDrawer = ({ onClose = () => {} }) => {
  const dispatch = useDispatch();
  const isSmall = useSelector((state) => state.app.isSmall);
  const isOpen = useSelector((state) => state.supportDrawer.isOpen);
  const contentId = useSelector((state) => state.supportDrawer.contentId);

  let hintList = [];
  let title = '';
  if (contentId) {
    hintList = SUPPORT_CONTENT_MAP[contentId]?.(i18n._).hintList;
    title = SUPPORT_CONTENT_MAP[contentId]?.(i18n._).title;
  }

  const handleSupportClose = () => {
    onClose();
    dispatch(closeSupportDrawer());
  };

  return (
    <Drawer open={isOpen} onClose={handleSupportClose} anchor='right'>
      <Paper className={isSmall ? 'supportDrawer-container' : 'supportDrawer-container_partScreen'}>
        <div className='supportDrawer-button'>
          <IconButton onClick={handleSupportClose} size='large'><CloseIcon /></IconButton>
        </div>
        <div className='supportDrawer-title'><Typography variant='h5'>{title}</Typography></div>
        <div>
          {hintList.map((hint) => {
            const Icon = hint.icon;
            return (
              <div className='supportDrawer-messageContainer' key={hint.title}>
                <Icon className='supportDrawer-icon' />
                <Typography variant='h6'>
                  <span className='supportDrawer-subtitle'>{hint.title}</span>
                </Typography>
                <Typography color='textSecondary' variant='body2'>
                  <span> {hint.text}</span>
                </Typography>
              </div>
            );
          })}
        </div>
      </Paper>
    </Drawer>
  );
};

export default SupportDrawer;
